export default "__VITE_ASSET__a52cd85d__"